import { TravelInsuranceType } from '@hyphengroup/cms-components/types/cmsEnums';
import { TravelCompareQuotesParams } from './types';

// Create a stable cache key for params
export function travelCompareQuotesParamsHash(
  p: Partial<TravelCompareQuotesParams>,
) {
  const keyable = {
    ...p,
    destinationIsoCodes: p.destinationIsoCodes?.slice().sort(),
  };
  return JSON.stringify(keyable, Object.keys(keyable).sort());
}

/**
 * Derives the trip types a provider actually offers from its product sets.
 * Without provider settings (e.g. the Result Page) both types stay available.
 */
export function getProviderTripTypes(providerSettings?: {
  productsSingle: unknown[];
  productsAnnual: unknown[];
}): TravelInsuranceType[] {
  if (!providerSettings) {
    return ['SINGLE_PLAN', 'ANNUAL_PLAN'];
  }

  const types: TravelInsuranceType[] = [];
  if (providerSettings.productsSingle.length) {
    types.push('SINGLE_PLAN');
  }
  if (providerSettings.productsAnnual.length) {
    types.push('ANNUAL_PLAN');
  }

  return types;
}
